<template>
  <Modal v-model="shipmentSettingsModal" :title="$t('key1004133')" width="550" :mask-closable="false">
    <Form ref="shipmentSettingsForm" :model="shipmentSettingsForm" @submit.native.prevent @on-visible-change="shipmentSettingsChange">
      <FormItem :label="$t('key1004005')" prop="enableWeight" class="radio_styles">
        <RadioGroup v-model="shipmentSettingsForm.enableWeight">
          <Radio label="Y">{{ $t('key1004137') }}</Radio>
          <Radio label="YES">{{ $t('key1004138') }}</Radio>
          <Radio label="N">{{ $t('key1004139') }}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('key1004134')" prop="weightUnit" class="radio_styles">
        <RadioGroup v-model="shipmentSettingsForm.weightUnit">
          <Radio label="g">g</Radio>
          <Radio label="kg">kg</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('key1004135')" prop="cutOff">
        <div class="flex align-items-center">
          <span>{{ $t('key1004140') }}</span>
          <InputNumber :min="1" :max="99999" :formatter="value => `${parseInt(value)}`" class="ml5 mr5"
            v-model.trim="shipmentSettingsForm.beforeInterception" style="width:100px;"></InputNumber>
          <span class="mr30">{{ $t('key1001247') }}</span>
          <span>{{ $t('key1004141') }}</span>
          <InputNumber :min="1" :max="99999" :formatter="value => `${parseInt(value)}`" class="ml5 mr5"
            v-model.trim="shipmentSettingsForm.afterInterception" style="width:100px;"></InputNumber>
          <span class="mr10">{{ $t('key1001247') }}</span>
          <Tooltip transfer max-width="400" :content="$t('key1004136')">
            <Icon class="font-size-19 cursor" style="color: #D7D7D7;" type="md-help-circle"></Icon>
          </Tooltip>
        </div>
      </FormItem>
    </Form>
    <template #footer>
      <Button @click="shipmentSettingsModal = false">{{ $t('key1000248') }}</Button>
      <Button type="primary" @click="shipmentSettingsBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'shipmentSettingsModal',
  mixins: [Mixin],
  data() {
    return {
      shipmentSettingsModal: false,
      shipmentSettingsForm: {
        enableWeight: 'Y', // Y 开启(必填) N 不开启  YES开启(非必填)
        weightUnit: 'g', //  g , kg
        beforeInterception: null, // 截取前
        afterInterception: null // 截取后
      },
    };
  },
  methods: {
    // 初始化数据
    initShipmentSettingsData(data) {
      let v = this;
      if (data) {
        data.forEach(i => {
          for (let key in v.shipmentSettingsForm) {
            if (i.paramKey === key) {
              v.shipmentSettingsForm[key] = i.paramValue;
              if (['beforeInterception', 'afterInterception'].includes(key)) {
                v.shipmentSettingsForm[key] = i.paramValue > 0 ? Number(i.paramValue) : null;
              }
            }
          }
        });
      }
      this.shipmentSettingsModal = true;
    },
    //保存按钮
    shipmentSettingsBtn() {
      let v = this;
      let arr = [];
      for (let key in v.shipmentSettingsForm) {
        arr.push({
          paramKey: key,
          paramValue: v.shipmentSettingsForm[key]
        });
      }
      v.axios.post(api.post_erpCommonSettingParam_save, {paramBoList: arr}, {loading: true}).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
          v.shipmentSettingsModal = false;
          v.$emit('updateData', true);
        }
      });
    },
    // 监听弹窗
    shipmentSettingsChange(value) {
      if (!value) {
        this.$refs['shipmentSettingsForm'].resetFields();
        this.shipmentSettingsForm.beforeInterception = null;
        this.shipmentSettingsForm.afterInterception = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
